import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/_services/admin.service';

@Component({
  selector: 'app-list-log',
  templateUrl: './listLog.component.html',
  styleUrls: ['./listLog.component.scss']
})
export class AdminListLogComponent implements OnInit {
  constructor(private adminService: AdminService) {}

  logs!: string[];

  ngOnInit(): void {
    this.adminService.listAdminLog().subscribe(l => {
      this.logs = l;
    });
  }
}
